// ABOUTME: Title of an object schema form, rendered under the sticky action bar like the EditNode node title.
// ABOUTME: Takes the same {formatId, formatDefault} pair the FormElement title prop used to take, plus an optional trail.

import { Box, Divider, KeyboardArrowRightIcon, Typography } from '@ds/coolshop';
import { PageTitle } from '@modules/ui';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { FormattedMessage } from 'react-intl';

export interface ProductFormTitleProps {
    formatId: string;
    formatDefault: string;
    /** Parent entities shown over the title (e.g. product info code, group name). */
    breadcrumb?: string[];
}

export const ProductFormTitle = ({
    formatId,
    formatDefault,
    breadcrumb,
}: ProductFormTitleProps) => (
    <Box pt={2}>
        {!!breadcrumb?.length && (
            <Breadcrumbs
                separator={<KeyboardArrowRightIcon fontSize="small" />}
                aria-label="form breadcrumb"
            >
                {breadcrumb.map(part => (
                    <Typography key={part} variant="body2" color="text.secondary">
                        {part}
                    </Typography>
                ))}
            </Breadcrumbs>
        )}
        <PageTitle mt={breadcrumb?.length ? 1 : 0}>
            <FormattedMessage id={formatId} defaultMessage={formatDefault} />
        </PageTitle>
        <Divider mt={2} />
    </Box>
);
